import { render, staticRenderFns } from "./Emoji.vue?vue&type=template&id=d1e5408a&"
import script from "./Emoji.vue?vue&type=script&lang=js&"
export * from "./Emoji.vue?vue&type=script&lang=js&"
import style0 from "./Emoji.vue?vue&type=style&index=0&id=d1e5408a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports